/**
 * System-role hierarchy — kept in sync with apps/backend/src/auth/roles.js.
 *
 *   owner > admin > usermanager > facilitator > participant
 *
 * Since #793 (specs/access-model.md) the role carries only system-wide
 * rights; what someone may do with one instance or dataset is their grant
 * in `me.grants`. `hasRole(user, 'admin')` admits both admins and owners
 * (rank-based). The viewer role is retired. A usermanager is the lead
 * facilitator (#1214): the server puts `manage` on every instance in their
 * `me.grants`, so the client needs no role check for it.
 */
export const ROLE_RANKS = {
  owner: 100,
  admin: 80,
  usermanager: 70,
  facilitator: 60,
  participant: 20,
};

export function rankOf(role) {
  return ROLE_RANKS[role] ?? 0;
}

export function hasRole(userOrRole, required) {
  const userRole = typeof userOrRole === 'string' ? userOrRole : userOrRole?.role;
  return rankOf(userRole) >= rankOf(required);
}
